import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Radio } from "lucide-react";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import TriageInbox from "@/pages/TriageInbox";
import OpportunityDetail from "@/pages/OpportunityDetail";
import AssetBank from "@/pages/AssetBank";
import Approvals from "@/pages/Approvals";
import CRM from "@/pages/CRM";
import Compliance from "@/pages/Compliance";
import AuditLog from "@/pages/AuditLog";

function Loading() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="grid h-12 w-12 place-items-center rounded-xl bg-primary/15 border border-primary/30 animate-pulse">
        <Radio className="h-6 w-6 text-primary" />
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/triage" element={<Protected><TriageInbox /></Protected>} />
      <Route path="/opportunity/:id" element={<Protected><OpportunityDetail /></Protected>} />
      <Route path="/assets" element={<Protected><AssetBank /></Protected>} />
      <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
      <Route path="/crm" element={<Protected><CRM /></Protected>} />
      <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
